/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'ai-mate.agent-header-banner-label': '客服人員橫幅',
  'ai-mate.agent-list.all-agents-section-title': '所有客服人員',
  'ai-mate.agent-list.beta-lozenge-title': '測試版',
  'ai-mate.agent-list.change-owner-success-flag-description': '您已將 {agentName} 的負責人變更為 {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': '已成功變更負責人',
  'ai-mate.agent-list.delete-agent-confirm-body': '您確定要刪除此客服人員嗎？此動作無法復原。',
  'ai-mate.agent-list.delete-agent-confirm-title': '要刪除「{agentName}」嗎？',
  'ai-mate.agent-list.delete-agent-error': '無法刪除客服人員',
  'ai-mate.agent-list.delete-agent-error-flag-description': '刪除客服人員時發生錯誤。請稍後再試一次。',
  'ai-mate.agent-list.delete-agent-error-flag-title': '無法刪除客服人員',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': '客服人員目前正在忙碌中。請稍後再試一次。',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': '找不到該客服人員。',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner': '您無法刪除並非自己建立的客服人員。請連絡客服人員負責人。',
  'ai-mate.agent-list.delete-agent-success-flag-description': '您已刪除「{agentName}」',
  'ai-mate.agent-list.delete-agent-success-flag-title': '已刪除客服人員',
  'ai-mate.agent-list.development-section-title': '開發客服人員',
  'ai-mate.agent-list.load-more-button-loading': '正在載入更多客服人員...',
  'ai-mate.agent-list.load-more-button-ready': '載入更多',
  'ai-mate.agent-list.loading-agents': '正在載入客服人員...',
  'ai-mate.agent-list.no-results': '找不到「{searchValue}」的結果',
  'ai-mate.agent-list.recommended-agents-section-title': '建議',
  'ai-mate.agent-list.searching-agents': '正在搜尋客服人員...',
  'ai-mate.agent-list.templates-description':
    '請使用這些範本來建立您自己的開發客服人員。為您的工作選擇合適的客服人員範本，選取「使用範本」，然後在範本提示中填寫存放庫、資料夾、語言和文件庫等具體詳細資料。建立客製化的開發客服人員，以便為不同的任務、專案或存放庫編碼。',
  'ai-mate.agent-list.templates-lozenge-title': '範本',
  'ai-mate.agent-list.templates-title': '編碼範本',
  'ai-mate.agent-message.agent-not-found': '找不到客服人員',
  'ai-mate.agent-message.convo-title': '與從智慧連結嵌入觸發的 {agentName} 聊天',
  'ai-mate.agent-message.copy-link': '複製客服人員連結',
  'ai-mate.agent-message.prompt': '提示',
  'ai-mate.agent-message.prompt-placeholder': '向 {agentName} 輸入訊息',
  'ai-mate.agent-message.prompt-submit': '提交',
  'ai-mate.agent-message.view-profile': '檢視設定檔',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': '取消',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': '刪除',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': '客服人員 · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': '與 {agentName} 聊天',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': '已複製 URL',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': '複製連結',
  'ai-mate.agent-profile-info.hidden-icon': '隱藏',
  'ai-mate.agent-profile-info.hidden-tooltip': '客服人員不會顯示在搜尋結果中',
  'ai-mate.agent-profile-info.star-agent-tooltip': '為客服人員標上星號',
  'ai-mate.agent-selector.agent-not-found': '找不到客服人員',
  'ai-mate.agent-selector.default-agent-description': '獲得答案、產生新構想，並加速日常工作。',
  'ai-mate.agent-selector.default-agent-name': '聊天',
  'ai-mate.browse-agents-view.close-button': '關閉客服人員檢視',
  'ai-mate.browse-agents.scenario-pill.default-scenario-tag': '預設',
  'ai-mate.browse-agents.scenario-pill.inactive-scenario-tooltip': '非作用中',
  'ai-mate.profile-card-preview.actions-title': '動作',
  'ai-mate.profile-card-preview.agent-default-title': '客服人員',
  'ai-mate.profile-card-preview.agent-description-label': '描述',
  'ai-mate.profile-card-preview.agent-title-label': '標題',
  'ai-mate.profile-card-preview.conversation-starters-heading': '對話啟動方式',
  'ai-mate.profile-card-preview.empty-actions': '無',
  'ai-mate.profile-card-preview.empty-conversation-starters': '無',
  'ai-mate.profile-card-preview.empty-instructions': '無',
  'ai-mate.profile-card-preview.empty-knowledge-scope': '未選取',
  'ai-mate.profile-card-preview.instructions-title': '指示',
  'ai-mate.profile-card-preview.knowledge-title': '知識',
  'ai-mate.profile-card-preview.regenerate-label': '重新產生「{fieldName}」',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - 副本',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': '拖曳以重新排序',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': '無法儲存變更',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error': '發生未知的錯誤。請再試一次',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error': '此名稱的客服人員已存在',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': '移除',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text': '產生對話啟動方式',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, other {{fieldName} 不能超過 {maxLength,number} 個字元}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': '下一步',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': '重新開始',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': '跳至手動設定',
  'create-agent.owner-field.confirm-modal-cancel': '取消',
  'create-agent.owner-field.confirm-modal-confirm': '是的，繼續',
  'create-agent.owner-field.confirm-modal-content':
    '您即將把此客服人員的負責人變更為 {name}。這麼做之後，您將無法再編輯或管理此客服人員。',
  'create-agent.owner-field.confirm-modal-title': '您即將失去編輯權限',
  'create-agent.owner-field.owner-description': '這是可以編輯或管理客服人員的人。',
  'create-agent.owner-field.owner-label': '負責人',
  'rovo-chat.agent-card.deactivated-name': '{name} (已停用)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': '要求過多。請稍候。',
  'rovo-chat.browse-agents.agents-error-try-again-button': '再試一次',
  'rovo-chat.browse-agents.all-agents-button': '全部',
  'rovo-chat.browse-agents.close-button': '關閉',
  'rovo-chat.browse-agents.create-agent-button': '建立',
  'rovo-chat.browse-agents.create-an-agent-button': '建立客服人員',
  'rovo-chat.browse-agents.create-button-disabled-tooltip': '您沒有在此網站中建立客服人員的權限',
  'rovo-chat.browse-agents.created-by-label': '<text>建立者為</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': '編碼客服人員',
  'rovo-chat.browse-agents.favorite-agents-button': '我的最愛',
  'rovo-chat.browse-agents.favourited-agent-label': '已加入最愛的客服人員',
  'rovo-chat.browse-agents.modal-title': '瀏覽客服人員',
  'rovo-chat.browse-agents.my-agents-button': '我的客服人員',
  'rovo-chat.browse-agents.no-created-agents':
    '您似乎尚未建立任何客服人員。請先複製其他現有的客服人員，或從頭開始建立客服人員。',
  'rovo-chat.browse-agents.no-created-agents-header': '尚未建立任何客服人員',
  'rovo-chat.browse-agents.no-created-agents-header-no-permission': '您尚未建立任何客服人員',
  'rovo-chat.browse-agents.no-created-agents-no-permission': '您需要管理員的權限，才能在此網站中建立 Rovo 客服人員。',
  'rovo-chat.browse-agents.no-starred-agents': '如果您有最喜歡或經常使用的客服人員，請標上星號以便輕鬆存取。',
  'rovo-chat.browse-agents.no-starred-agents-header': '你尚未啟動客服人員',
  'rovo-chat.browse-agents.search-input.placeholder': '搜尋客服人員',
  'rovo-chat.browse-agents.search-templates-input.placeholder': '搜尋範本',
  'rovo-chat.browse-agents.see-all-agents-button': '查看所有客服人員',
  'rovo-chat.browse-agents.templates-button': '範本',
  'rovo-chat.create-agent.actions-section-description':
    '為您的客服人員新增動作，以在 Jira、Confluence 和 Jira Service Management 中執行任務。<link>什麼是客服人員動作？</link>',
  'rovo-chat.create-agent.add-actions-button-label': '新增動作',
  'rovo-chat.create-agent.all-content-label': '所有內容',
  'rovo-chat.create-agent.back-button': '返回',
  'rovo-chat.create-agent.beta-lozenge': '測試版',
  'rovo-chat.create-agent.confirm-leave-modal.body': '您尚未建立客服人員，要將其捨棄嗎？',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': '取消',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': '是的，捨棄客服人員',
  'rovo-chat.create-agent.confirm-leave-modal.title': '未完成的客服人員',
  'rovo-chat.create-agent.confirm-restart-modal.body': '您確定要捨棄您對此客服人員所做的變更嗎？',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': '確認',
  'rovo-chat.create-agent.confirm-restart-modal.title': '重新開始建立',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    '使用者可以使用這些方式，與客服人員開始聊天。如果您想不到有哪些方式能使用，我們可以為您產生。',
  'rovo-chat.create-agent.conversation-starters-field-label': '對話啟動方式',
  'rovo-chat.create-agent.create-agent-button': '建立',
  'rovo-chat.create-agent.ctions-section-title': '動作',
  'rovo-chat.create-agent.description-field-description': '使用者可以使用客服人員設定檔中的描述來深入了解。',
  'rovo-chat.create-agent.description-field-label': '描述',
  'rovo-chat.create-agent.description-field-placeholder': '撰寫與客服人員有關的簡要描述 (例如，行銷部落格的創意作者)',
  'rovo-chat.create-agent.instructions-field-description':
    '您希望這個客服人員做什麼？要有哪些功能？<link>進一步了解如何撰寫指示給客服人員</link>',
  'rovo-chat.create-agent.instructions-field-label': '指示',
  'rovo-chat.create-agent.instructions-field-placeholder': '自訂此客服人員的指示',
  'rovo-chat.create-agent.intro-description-part-1':
    '建立具有專業知識的客服人員，以回答問題、撰寫和審閱內容，並且執行任務，協助您推動工作進展。',
  'rovo-chat.create-agent.intro-description-part-2': '如果您不需要協助，可以<bold>跳到手動設定。</bold>',
  'rovo-chat.create-agent.intro-description-part-3': '否則請留在此處，一起建置客服人員。',
  'rovo-chat.create-agent.intro-step-1-content':
    '我會根據您撰寫的內容，為客服人員建立指示。請告訴我您打算將客服人員用於何種用途。',
  'rovo-chat.create-agent.intro-step-1-title': '描述您想要客服人員做的事',
  'rovo-chat.create-agent.intro-step-2-content':
    '一起來決定客服人員的名稱和個性。客服人員的個性可以是善解人意、溝通直接或是風趣幽默。',
  'rovo-chat.create-agent.intro-step-2-title': '賦予一些性格特色',
  'rovo-chat.create-agent.intro-step-3-content':
    '選取<bold>下一步</bold>以檢閱新的客服人員、新增動作、知識和設定檔相片。全部完成後，請選取<bold>建立</bold>。',
  'rovo-chat.create-agent.intro-step-3-content-skills':
    '點擊<bold>下一步</bold>以檢閱新的客服人員、新增技能、知識和設定檔圖片。全部完成後，請選取<bold>建立</bold>。',
  'rovo-chat.create-agent.intro-step-3-title': '檢閱並建立客服人員',
  'rovo-chat.create-agent.intro-title': '👋 一起來建立客服人員',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': '所有專案',
  'rovo-chat.create-agent.jira-filter-placeholder-galaxia': '所有空間',
  'rovo-chat.create-agent.jsm-checkbox-label': 'Jira Service Management',
  'rovo-chat.create-agent.jsm-filter-knowledge-base-placeholder': '搜尋知識庫',
  'rovo-chat.create-agent.knowledge-field-description': '只允許客服人員參照您提供的來源，以指定客服人員的知識',
  'rovo-chat.create-agent.knowledge-field-label': '知識',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': '只參照這些來源',
  'rovo-chat.create-agent.knowledge-select.object-resolver-label': '連結',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': '建議',
  'rovo-chat.create-agent.manage-actions-button-label': '管理動作',
  'rovo-chat.create-agent.name-field-description': '使用者可以使用此欄位來尋找客服人員。',
  'rovo-chat.create-agent.name-field-label': '名稱',
  'rovo-chat.create-agent.name-field-placeholder': '為客服人員命名',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error': '發生未預期的錯誤。請再試一次。',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    '您好！我可以協助您建置自訂客服人員。您希望客服人員做哪些事？',
  'rovo-chat.create-agent.nl-input-field.input-label': '建立客服人員',
  'rovo-chat.create-agent.nl-input-field.placeholder': '輸入您的訊息',
  'rovo-chat.create-agent.nl-input-field.send-button-label': '傳送',
  'rovo-chat.create-agent.page-title': '建立客服人員',
  'rovo-chat.create-agent.page-title-edit': '編輯客服人員',
  'rovo-chat.create-agent.search-for-pages-placeholder': '搜尋頁面',
  'rovo-chat.create-agent.search-for-spaces-placeholder': '搜尋空間',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': '全部',
  'rovo-chat.create-agent.select-action-modal-beta-tag': '測試版',
  'rovo-chat.create-agent.select-action-modal-cancel-button': '取消',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': '關閉',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, other {選取少於 {count,number} 個動作可達到最佳效能}}',
  'rovo-chat.create-agent.select-action-modal-save-button': '儲存',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': '搜尋動作',
  'rovo-chat.create-agent.select-action-modal-title': '新增動作',
  'rovo-chat.create-agent.select-content-under-label': '在下方選取內容',
  'rovo-chat.create-agent.select-spaces-label': '選取空間',
  'rovo-chat.create-agent.selected-actions-label': '已選取的動作：',
  'rovo-chat.create-agent.unknown-owner': '未知',
  'rovo-chat.create-agent.update-agent-button': '更新',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    '如果繼續，未儲存的變更將會遺失。選取「取消」即可繼續編輯此客服人員。',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': '繼續，刪除變更',
  'rovo-chat.edit-agent.confirm-discard-modal.title': '捨棄變更',
  'rovo-chat.view-agent.about-label': '關於',
  'rovo-chat.view-agent.actions-label': '動作',
  'rovo-chat.view-agent.agent-instructions.copy-label': '複製',
  'rovo-chat.view-agent.agent-instructions.copy-tooltip': '複製指示',
  'rovo-chat.view-agent.agent-instructions.placeholder': '此客服人員沒有自訂指示',
  'rovo-chat.view-agent.all-knowledge-added': '所有組織知識',
  'rovo-chat.view-agent.behaviour-label': '行為',
  'rovo-chat.view-agent.beta-label': '測試版',
  'rovo-chat.view-agent.beta-tag': '測試版',
  'rovo-chat.view-agent.chat-to-agent-button': '與客服人員聊天',
  'rovo-chat.view-agent.close-button': '關閉',
  'rovo-chat.view-agent.copied-instructions-tooltip-label': '已複製',
  'rovo-chat.view-agent.copy-instructions-tooltip-label': '複製',
  'rovo-chat.view-agent.created-by-label': '<text>建立者為</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': '我的最愛的數量',
  'rovo-chat.view-agent.go-back-label': '返回',
  'rovo-chat.view-agent.hidden-instructions-description': '使用程式碼建置的 Forge 客服人員會隱藏指示，以確保隱私權。',
  'rovo-chat.view-agent.hidden-instructions-title': '這些是私密指示',
  'rovo-chat.view-agent.hidden-knowledge-description': '使用程式碼建置的 Forge 客服人員不會使用典型的知識來源',
  'rovo-chat.view-agent.inactive-action-tooltip': '非作用中',
  'rovo-chat.view-agent.instructions-label': '指示',
  'rovo-chat.view-agent.knowledge-label': '知識',
  'rovo-chat.view-agent.member-count': '{count, plural, other {{count,number} 位成員}}',
  'rovo-chat.view-agent.modal-title': '瀏覽客服人員',
  'rovo-chat.view-agent.no-actions': '沒有動作',
  'rovo-chat.view-agent.no-behaviour-placeholder': '此客服人員沒有自訂行為',
  'rovo-chat.view-agent.no-instruction-placeholder': '此客服人員沒有自訂指示',
  'rovo-chat.view-agent.no-knowledge-added': '沒有組織知識',
  'rovo-chat.view-agent.no-scenarios': '沒有案例',
  'rovo-chat.view-agent.no-skills': '沒有技能',
  'rovo-chat.view-agent.no-teams': '不屬於任何團隊',
  'rovo-chat.view-agent.open-chat-label': '開啟聊天',
  'rovo-chat.view-agent.reactions-metadata-label': '回應的數量',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo 客服人員',
  'rovo-chat.view-agent.scenarios-label': '案例',
  'rovo-chat.view-agent.skills-label': '技能',
  'rovo-chat.view-agent.teams-label': '團隊',
  'rovo-chat.view-agent.users-metadata-label': '使用者的數量',
  'rovo.agent.scenarios.scenarioModal.actionsLabel': '動作',
  'rovo.agent.scenarios.scenarioModal.instructionsLabel': '指示',
  'rovo.agent.scenarios.scenarioModal.knowledgeSourcesLabel': '知識',
  'rovo.agent.scenarios.scenarioModal.mcpServersLabel': 'MCP 伺服器',
  'rovo.agent.scenarios.scenarioModal.noActions': '沒有動作',
  'rovo.agent.scenarios.scenarioModal.noInstructions': '沒有指示',
  'rovo.agent.scenarios.scenarioModal.noMcpServers': '沒有 MCP 伺服器',
  'rovo.agent.scenarios.scenarioModal.noSkills': '沒有技能',
  'rovo.agent.scenarios.scenarioModal.skillsLabel': '技能',
  'rovo.conversation.assistant.agent.deepResearchPill': '深入研究',
};
